// The <- button to be displayed in title bars.
import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { IconDownload, IconTrash } from '../icons/svg';

export const TYPE_BTN = {
  DOWNLOAD: 1,
  DELETE: 2
}

class ButtonSticker extends React.PureComponent {
  constructor(props) {
    super(props);

    this.renderBtn = this.renderBtn.bind(this);
  }

  renderBtn() {
    const { type } = this.props;
    switch (type) {
      case TYPE_BTN.DOWNLOAD:
        return (
          <React.Fragment>
            <IconDownload />
            <FormattedMessage id='download_action' defaultMessage={'download'} />
          </React.Fragment>
        )
      case TYPE_BTN.DELETE:
        return (
          <React.Fragment>
            <IconTrash />
            <FormattedMessage id='delete_action' defaultMessage={'delete'} />
          </React.Fragment>
        )
      default:
        break;
    }
  }
  render() {
    return (
      <button className='btn-sticker' onClick={this.props.onClick}>
        {this.renderBtn()}
      </button>
    );
  }
}

export default injectIntl(ButtonSticker);